module.exports = __webpack_public_path__ + "img/line.42b4c52d.svg";